import React from "react";
import ReactGA from "react-ga";
import { ThemeProvider } from "styled-components";
import { createStore } from "redux";
import { Provider } from "react-redux";
import { BrowserRouter as Router, Route, Switch } from "react-router-dom";

import appReducer from "./redux/reducers";
import appTheme from "./themes/appTheme";

import Application from "./application/Application";
import WelcomePage from "./welcome-page/WelcomePage";

const appStore = createStore(
  appReducer,
  window.__REDUX_DEVTOOLS_EXTENSION__ && window.__REDUX_DEVTOOLS_EXTENSION__()
);

ReactGA.initialize("UA-8858797-14");
ReactGA.pageview(window.location.pathname + window.location.search);

const App = () => (
  <Router>
    <Provider store={appStore}>
      <ThemeProvider theme={appTheme}>
        <div>
          <Route exact path="/" component={WelcomePage} />
          <Route path="/tutorial" component={Application} />
        </div>
      </ThemeProvider>
    </Provider>
  </Router>
);

export default App;



// WEBPACK FOOTER //
// ./src/App.js